import HeaderMeta from 'components/headerMeta/HeaderMeta';
import Footer from 'components/layout/Footer';
import { useEffect } from 'react';
import { buildPageBreadcrumb } from 'untils/jsonLdSchemas';
import Content from './components/Content';
import Header from './components/Header';
import { H1, JetMain, P } from './Jet.style';

const HeaderContent = {
  url: '/contactUs',
  urlText: 'CONTACT US',
  imgUrl: '/imgs/webp/jet/head.webp',
  titleContent: (
    <H1>
      Explore Private Jets <br />& Discover the Perfect Aircraft for Your Trip
    </H1>
  ),
  descContent: (
    <P $color="#fff">
      From booking tickets to taking off, you deserve to travel in comfort. Welcome to a world where
      your flying needs are heard. We aim to provide an excellent flying experience for all
      passengers, no matter your party size, travel distance, or disability status.
    </P>
  ),
};

const Jet = () => {
  const { url, urlText, imgUrl, titleContent, descContent } = HeaderContent;
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(decodeURIComponent(hash.slice(1)));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  return (
    <JetMain>
      <HeaderMeta type="jetType" jsonLd={[buildPageBreadcrumb('Jets', '/jet')]} />
      <Header
        urlText={urlText}
        url={url}
        imgUrl={imgUrl}
        titleContent={titleContent}
        descContent={descContent}
        height={'600'}
      />
      <Content />
      <Footer />
    </JetMain>
  );
};

export default Jet;
